import { TRACK_IDS } from "../../../analytics/trackIds";
import React, { useEffect, useRef, useState } from "react";
import localizationStrings from "../../../statics/localization";
import PlaybackRateIcon from "../../../assets/icons/svg/PlaybackRateIcon";
import PlayerMenu from "./PlayerMenu";

const SPEEDS = [0.5, 1, 1.25, 1.5];
export default function PlaybackRate({ player }) {
  const [rate, setRate] = useState(1);
  const [open, setOpen] = useState(false);
  const button = useRef(null);
  const label =
    localizationStrings.speed ||
    localizationStrings.playSpeed ||
    "Playback speed";
  useEffect(() => {
    const update = () => setRate(player.playbackRate());
    update();
    player.on("ratechange", update);
    return () => player.off("ratechange", update);
  }, [player]);
  const close = (restoreFocus) => {
    setOpen(false);
    if (restoreFocus && button.current) button.current.focus();
  };
  return (
    <>
      <button
        ref={button}
        type="button"
        data-track-id={TRACK_IDS.PLAYER_PLAYBACK_RATE}
        className="control-button playback-rate-button"
        title={label}
        aria-label={label}
        aria-expanded={open}
        aria-haspopup="dialog"
        onClick={() => setOpen(!open)}
      >
        <PlaybackRateIcon />
      </button>
      {open && (
        <PlayerMenu
          player={player}
          anchorRef={button}
          label={label}
          width={190}
          onClose={close}
        >
          <div role="radiogroup" aria-label={label}>
            <h3>{label}</h3>
            {SPEEDS.map((value) => (
              <button
                key={value}
                type="button"
                role="radio"
                aria-checked={rate === value}
                onClick={() => {
                  player.playbackRate(value);
                  setRate(value);
                  close(true);
                }}
              >
                {value === 1 ? "Normal" : `${value}x`}
              </button>
            ))}
          </div>
        </PlayerMenu>
      )}
    </>
  );
}
